import actions from '../../actionTypes';

export default nodeAddress => {
  return {
    type: actions.DELETE_SITE_AP_SUCCESS,
    nodeAddress
  };
};



// WEBPACK FOOTER //
// ./src/reducers/status/actions/removeSiteAccessPointSuccess.js